import Rest from '@/services/Rest';

/**
 * @typedef {ModuleService}
 */
export default class ModuleService extends Rest {
    /**
     * @type {String}
     */
    static resource = 'notify'
}